import { Link } from '@on3/ui-lib/components/Link';
import clsx from 'clsx';
import { useRouter } from 'next/router';

import styles from './TeamMiniNav.module.scss';

export const TeamMiniNav = () => {
  const { pathname, query } = useRouter();
  const { type } = query;
  const isCollegePath = pathname.includes('college');
  const isTeamPath = pathname.includes('teams') && !type;

  return (
    <div className={styles.topnav}>
      <Link
        className={clsx(styles.toplink, {
          [styles.active]: isCollegePath,
        })}
        href="/college/"
      >
        Team Channels
      </Link>
      <Link
        className={clsx(styles.toplink, {
          [styles.active]: isTeamPath,
        })}
        href="/teams/"
      >
        Fan Sites
      </Link>
      <Link
        className={clsx(styles.toplink, {
          [styles.active]: !!type,
        })}
        href="/teams/?type=highschool"
      >
        High School
      </Link>
    </div>
  );
};
